<template>
  <v-dialog v-model="isVisible" width="25rem">
    <v-card>
      <v-card-item>
        <v-card-title class="text-wrap">
          {{ title }}
        </v-card-title>
      </v-card-item>
      <v-card-text>
        {{ message }}
      </v-card-text>
      <v-card-subtitle v-if="requireConfirmText">
        {{ $t('confirmDialog.typeConfirmText', { confirmText: requireConfirmText }) }}
      </v-card-subtitle>
      <v-card-text v-if="requireConfirmText">
        <v-text-field
          v-model="confirmText"
          :placeholder="requireConfirmText"
          variant="outlined"
          hide-details
        ></v-text-field>
      </v-card-text>
      <v-card-text v-if="disabledActionText && disabledAction" class="py-0">
        <v-alert type="info" variant="tonal" density="compact">
          <template #prepend>
            <v-icon size="small" class="mb-n6">mdi-alert-circle-outline</v-icon>
          </template>
          {{ disabledActionText }}
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="cancel">
          {{ $t('confirmDialog.cancel') }}
        </v-btn>
        <v-btn
          @click="confirm"
          :color="dangerButton ? 'red' : 'primary'"
          :variant="dangerButton ? 'outlined' : undefined"
          :disabled="!allowProceed || disabledAction"
        >
          <v-icon v-if="dangerButton" start>mdi-alert-outline</v-icon>
          {{ proceedText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
      required: false
    },
    message: {
      type: String,
      default: null,
      required: false
    },
    dangerButton: {
      type: Boolean,
      default: false,
      required: false
    },
    actionText: {
      type: String,
      default: null,
      required: false
    },
    requireConfirmText: {
      type: String,
      default: null,
      required: false
    },
    disabledAction: {
      type: Boolean,
      default: false,
      required: false
    },
    disabledActionText: {
      type: String,
      default: null,
      required: false
    }
  },
  data() {
    return {
      isVisible: false,
      resolve: null,
      reject: null,
      confirmText: ''
    }
  },

  watch: {
    isVisible(val) {
      if (val) {
        this.confirmText = ''
      }
    }
  },
  computed: {
    allowProceed() {
      return this.requireConfirmText ? this.confirmText === this.requireConfirmText : true
    },

    proceedText() {
      return this.actionText ? this.actionText : this.$t('confirmDialog.defaultActionText')
    },

    confirmMessage() {
      return this.message ? this.message : this.$t('confirmDialog.defaultMessage')
    }
  },

  methods: {
    show() {
      this.isVisible = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    confirm() {
      if (this.resolve) {
        this.resolve(true)
        this.closeDialog()
      }
    },
    cancel() {
      if (this.reject) {
        this.resolve(false)
        this.closeDialog()
      }
    },
    closeDialog() {
      this.isVisible = false
      this.resolve = null
      this.reject = null
    }
  }
}
</script>
